module.exports = __webpack_public_path__ + "img/Dynatrace.97b8dcef.png";